// extracted by mini-css-extract-plugin
module.exports = {"SuccessStoriesObserver":"success-stories-observer_SuccessStoriesObserver__dmzzW"};